import React from 'react';
import '../UserInterface/LoadingSpinner.module.css';

export default function LoadingSpinner() {
  return <div className="spinner">Loading...</div>;
}